import * as React from 'react';
import styled from '@emotion/styled';
import { Controller } from 'react-hook-form';
import { FaTrashAlt } from 'react-icons/fa';
import { matcherTypes } from '../../../hooks/dlq-ignore-rules-api';
import { Row, Field, IconButton, Title4, InstructionsSmall, Selectorator } from '../../../components';
import { ReactHookFormField } from '../../../components/react-hook-form-field';
const Styles = styled.div `
  margin: 0.5rem 0;
  padding: 0.25rem 0.5rem;
  background: white;
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`;
const showGenericMatcherField = (matcherType, field) => {
    switch (matcherType) {
        case 'isTruthy':
        case 'isFalsy':
        case 'isNull':
        case 'isEmpty':
        case 'isUndefined':
            return false;
        case 'pattern':
            return true;
        case 'primitive':
            return field === 'matchVal';
    }
};
export const GenericMatcherForm = ({ item, index, form: { control, watch }, remove, keyPrefix, }) => {
    const ruleType = watch('ignoreRulesType');
    const matcherType = watch(`${keyPrefix}.${index}.matcherType`);
    return (React.createElement(Styles, null,
        React.createElement(Title4, null,
            "#",
            index + 1),
        React.createElement(InstructionsSmall, null, "(each of these act as an AND)"),
        React.createElement(Row, null,
            typeof item.stepName === 'string' && (React.createElement(ReactHookFormField, { hooksFormControl: control, name: `${keyPrefix}.${index}.stepName`, label: "Step Name", placeholder: "eg: STEP_UPDATE_USER_LOGIN_TS", isRequired: true })),
            React.createElement(ReactHookFormField, { hooksFormControl: control, name: `${keyPrefix}.${index}.key`, label: "Key", placeholder: "eg: someProp.[any|all].p.yetAnotherProp", disabled: ruleType === 'FARKEN-ERROR', isRequired: true }),
            React.createElement(Controller, { name: `${keyPrefix}.${index}.matcherType`, render: ({ field }) => (React.createElement(Selectorator, { label: "Type", name: "matcherType", list: matcherTypes, select: (val) => field.onChange(val), selected: field.value })), control: control })),
        React.createElement(Row, null,
            showGenericMatcherField(matcherType, 'matchVal') && (React.createElement(ReactHookFormField, { hooksFormControl: control, name: `${keyPrefix}.${index}.matchVal`, label: "Matcher Val", placeholder: "Matcher Val", isRequired: true })),
            showGenericMatcherField(matcherType, 'matchFlag') && (React.createElement(Controller, { name: `${keyPrefix}.${index}.matchFlag`, render: ({ field }) => React.createElement(Field, Object.assign({}, field, { label: "Matcher Flag", placeholder: "eg. gi" })), control: control }))),
        React.createElement(IconButton, { type: "button", onClick: () => remove(index) },
            React.createElement(FaTrashAlt, null))));
};
//# sourceMappingURL=generic-matcher-form.js.map